module.exports = __webpack_public_path__ + "static/media/modern-design.930b558d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modern-design.jpg
// module id = 919
// module chunks = 0